import { ApiPricingData } from '@/@types/bankroll';

export const init: ApiPricingData = {
  appId: '11EC32711C120570A8E252732F4B14CD',
  defPackageId: 'AFB748FBCAA91F37C3C47D894693C904',
  bestPackageId: 'AFB748FBCAA91F37C3C47D894693C904',
  packageList: [
    {
      type: 'membership',
      id: 'AFB748FBCAA91F37C3C47D894693C904',
      packageKey: 'lilyplant:trial_1y',
      period: '3d',
      price: {
        amount: '0.99',
        prefixAmount: '0',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 99,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: '4AB3B339B50AD4F4EEBA10F4E182CF28',
        packageKey: 'lilyplant:1y',
        period: '1y',
        price: {
          amount: '39.99',
          prefixAmount: '39',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 3999,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: '1E7BCD6E9E15C810E6998D67399E1483',
      packageKey: 'lilyplant:trial_limited_1y',
      period: '3d',
      price: {
        amount: '0.99',
        prefixAmount: '0',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 99,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: '59558E097EA0CD3A7E2CF83A14577B58',
        packageKey: 'lilyplant:limited_1y',
        period: '1y',
        price: {
          amount: '23.99',
          prefixAmount: '23',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 2399,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: '4AB3B339B50AD4F4EEBA10F4E182CF28',
      packageKey: 'lilyplant:1y',
      period: '1y',
      price: {
        amount: '39.99',
        prefixAmount: '39',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 3999,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: '4AB3B339B50AD4F4EEBA10F4E182CF28',
        packageKey: 'lilyplant:1y',
        period: '1y',
        price: {
          amount: '39.99',
          prefixAmount: '39',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 3999,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: '5A57F336C3F41C5D09E0908DBE7CF138',
      packageKey: 'lilyplant:1m',
      period: '1m',
      price: {
        amount: '12.99',
        prefixAmount: '12',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 1299,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: '5A57F336C3F41C5D09E0908DBE7CF138',
        packageKey: 'lilyplant:1m',
        period: '1m',
        price: {
          amount: '12.99',
          prefixAmount: '12',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 1299,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: 'C4F858078D21103D522C5E3DD65FF141',
      packageKey: 'lilyplant:99y',
      period: '99y',
      price: {
        amount: '59.99',
        prefixAmount: '59',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 5999,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: 'C4F858078D21103D522C5E3DD65FF141',
        packageKey: 'lilyplant:99y',
        period: '99y',
        price: {
          amount: '59.99',
          prefixAmount: '59',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 5999,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: '59558E097EA0CD3A7E2CF83A14577B58',
      packageKey: 'lilyplant:limited_1y',
      period: '1y',
      price: {
        amount: '23.99',
        prefixAmount: '23',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 2399,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: '59558E097EA0CD3A7E2CF83A14577B58',
        packageKey: 'lilyplant:limited_1y',
        period: '1y',
        price: {
          amount: '23.99',
          prefixAmount: '23',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 2399,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: 'B6C49F378AA5F63CE7D6804F702D2479',
      packageKey: 'lilyplant:limited_1m',
      period: '1m',
      price: {
        amount: '7.99',
        prefixAmount: '7',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 799,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: 'B6C49F378AA5F63CE7D6804F702D2479',
        packageKey: 'lilyplant:limited_1m',
        period: '1m',
        price: {
          amount: '7.99',
          prefixAmount: '7',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 799,
        },
        payPermissionType: 1,
      },
    },
    {
      type: 'membership',
      id: 'D00D7E4181C78DB03BF292D281F247EE',
      packageKey: 'lilyplant:limited_99y',
      period: '99y',
      price: {
        amount: '35.99',
        prefixAmount: '35',
        suffixAmount: '99',
        currency: 'USD',
        currencySymbol: '$',
        currencyPosition: 'prefix',
        amountInt: 3599,
      },
      payPermissionType: 1,
      packageForRepeat: {
        type: 'membership',
        id: 'D00D7E4181C78DB03BF292D281F247EE',
        packageKey: 'lilyplant:limited_99y',
        period: '99y',
        price: {
          amount: '35.99',
          prefixAmount: '35',
          suffixAmount: '99',
          currency: 'USD',
          currencySymbol: '$',
          currencyPosition: 'prefix',
          amountInt: 3599,
        },
        payPermissionType: 1,
      },
    },
  ],
  paymentMethodList: {
    CreditCard: {
      availableCardTypes: ['Visa', 'MasterCard'],
    },
  },
  bonusForPackage: [],
  requestValidationToken: '619664d22cd329.0111686141139',
  packageType: 'membership',
};
